import { render, staticRenderFns } from "./GpuMonitor.vue?vue&type=template&id=6f59fed2&scoped=true"
import script from "./GpuMonitor.vue?vue&type=script&lang=js"
export * from "./GpuMonitor.vue?vue&type=script&lang=js"
import style0 from "./GpuMonitor.vue?vue&type=style&index=0&id=6f59fed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f59fed2",
  null
  
)

export default component.exports